module.exports = __webpack_public_path__ + "static/img/cn018.12ad71e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cn018.jpg
// module id = eVVq
// module chunks = 1